import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FileRoutingModule } from './file-routing.module';
import { PreviewComponent } from './preview/preview.component';
import { PreviewImageComponent } from './preview-image/preview-image.component';
import { ComponentsModule } from '@material-library';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PreviewDocComponent } from './preview-doc/preview-doc.component';
import { SharedModule } from '../shared/shared.module';
import { PreviewTextComponent } from './preview-text/preview-text.component';
import { PreviewWopiComponent } from './preview-wopi/preview-wopi.component';
import { HistoryComponent } from './history/history.component';
import { PreviewVideoComponent } from './preview-video/preview-video.component';
import { PreviewAudioComponent } from './preview-audio/preview-audio.component';
import { PreviewDefaultComponent } from './preview-default/preview-default.component';
import { PreviewErrorComponent } from './preview-error/preview-error.component';
import { PreviewLinkComponent } from './preview-link/preview-link.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PreviewDialogComponent } from './history/preview-dialog/preview-dialog.component';
import { WopiOptinComponent } from './wopi-optin/wopi-optin.component';

@NgModule({
  declarations: [ 
    PreviewComponent, 
    PreviewImageComponent, 
    PreviewDocComponent, 
    PreviewTextComponent, 
    PreviewWopiComponent, 
    PreviewVideoComponent, 
    PreviewAudioComponent,
    HistoryComponent, 
    PreviewDefaultComponent,
    PreviewErrorComponent,
    PreviewLinkComponent,
    PreviewDialogComponent,
    WopiOptinComponent,
  ],
  imports: [
    CommonModule,
    FileRoutingModule,
    ComponentsModule,
    MatTooltipModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class FileModule { }
